import gql from 'graphql-tag';

import { FRAGMENT_BRAND_TERM } from 'src/graphql/brandTerms/schema';
import { FRAGMENT_BRAND_BRIEF } from 'src/graphql/brief/schema';
import { executeGqlQuery } from 'src/graphql/client';
import { CUSTOMER_PERSONA_FRAGMENT } from 'src/graphql/customerPersona';
import { CUSTOM_DATASET_FRAGMENT } from 'src/graphql/customModel/schema';
import { FRAGMENT_CUSTOM_FORMULA } from 'src/graphql/formula/schema';
import { FRAGMENT_CUSTOM_TONE_OF_VOICE } from 'src/graphql/toneOfVoice/schema';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_BRAND_VOICE } from './schema';

const QUERY = gql`
  query BrandVoiceWithAssets($id: ID!) {
    brandVoice(id: $id) {
      ...BrandVoice
      brandTerms {
        ...BrandTerm
      }
      brandBriefs {
        ...BrandBrief
      }
      targetAudiences {
        ...CustomerPersona
      }
      toneOfVoices {
        ...CustomToneOfVoice
      }
      customFormulas {
        ...CustomFormula
      }
      customModels {
        ...CustomDataset
      }
    }
  }
  ${FRAGMENT_BRAND_VOICE}
  ${FRAGMENT_BRAND_TERM}
  ${FRAGMENT_BRAND_BRIEF}
  ${CUSTOMER_PERSONA_FRAGMENT}
  ${FRAGMENT_CUSTOM_TONE_OF_VOICE}
  ${FRAGMENT_CUSTOM_FORMULA}
  ${CUSTOM_DATASET_FRAGMENT}
`;

export const queryBrandVoiceWithAssets = async (id) => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables: { id },
  });
  return getSingleProp(result.data);
};
